import { pushIf } from '@eturi/util'
import { findOnboardingByAge, type OnboardingAllowance } from '@op/services'
import type { AllowanceOpt } from '../../Allowance/useAllowanceOpts'
import type { SectionBoxSmallWithId } from '../types'

export const getOnboardingAllowance = (
	opts: AllowanceOpt[],
	allowance: OnboardingAllowance[],
	age: number,
): SectionBoxSmallWithId[] => {
	const selectedAllowance = findOnboardingByAge(allowance, age)
	if (!selectedAllowance) return []

	const { daily_limit, weekend_limit } = selectedAllowance

	const getAllowanceProps = (id: string, title: string, minutes: number) => {
		const secs = minutes
		const label = opts.find((opt) => Number(opt.value) === Number(secs))?.label
		return label ? { id, status: label, title } : null
	}

	const dailyProps = getAllowanceProps('daily', 'Daily Limits', daily_limit)
	const weekendProps = getAllowanceProps('weekend', 'Weekend Limits', weekend_limit)

	return [...pushIf(dailyProps), ...pushIf(weekendProps)]
}
